
export interface BaseReturnApi<key> {
  message : string ,
  statusCode : string ,
  isSuccess : boolean ,
  data : key
}
export interface AuthModel {
  access_token: string
  refresh_token?: string,
  expireDate : Date
}

export interface UserAddressModel {
  addressLine: string
  city: string
  state: string
  postCode: string
}

export interface UserCommunicationModel {
  email: boolean
  sms: boolean
  phone: boolean
}

export interface UserEmailSettingsModel {
  emailNotification?: boolean
  sendCopyToPersonalEmail?: boolean
  activityRelatesEmail?: {
    youHaveNewNotifications?: boolean
    youAreSentADirectMessage?: boolean
    someoneAddsYouAsAsAConnection?: boolean
    uponNewOrder?: boolean
    newMembershipApproval?: boolean
    memberRegistration?: boolean
  }
  updatesFromKeenthemes?: {
    newsAboutKeenthemesProductsAndFeatureUpdates?: boolean
    tipsOnGettingMoreOutOfKeen?: boolean
    thingsYouMissedSindeYouLastLoggedIntoKeen?: boolean
    newsAboutStartOnPartnerProductsAndOtherServices?: boolean
    tipsOnStartBusinessProducts?: boolean
  }
}

export interface UserSocialNetworksModel {
  linkedIn: string
  facebook: string
  twitter: string
  instagram: string
}

export interface UserModel {
  id: number
  username?: string
  password: string | undefined
  email?: string
  address:string,
  fullName?: string
  occupation?: string
  companyName?: string
    phoneNumber: string
  roles?: Array<string>
  userImage?: string,
  language?: 'en' | 'de' | 'es' | 'fr' | 'ja' | 'zh' | 'ru'
  timeZone?: string
  website?: 'https://keenthemes.com'
  emailSettings?: UserEmailSettingsModel
  auth?: AuthModel
  communication?: UserCommunicationModel
  // address?: UserAddressModel
  socialNetworks?: UserSocialNetworksModel
  isActive? : boolean ,
  emplyeCount ?: number ,
  manufacturyCount? : number ,
  listCount? : number ,
  userPhone?: string ,
  userWallet? : number ,
  tiketCount? : number ,
  tiketPendingCount? : number,
  vipExpress? : string,
  dateTimeVipExpress? : Date,
  nationalCode ? :string,
  phone?:string,
  clientType : ClientType,
  postalCode?:string

}
export enum ClientType {
  PersonEntity,
  LegalEntity
}
